export default __webpack_public_path__ + "static/media/pro-1.7639c3f9.png";